/**************************************************
 * Nombre:       BarraPc
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import logo from '../../Recursos/logo_color.svg'
import {NEGRITA, REDES, SECCIONES} from "../../Constantes";
import {WhatsApp} from '@mui/icons-material'
import {theme} from "../../Tema";
import {useIrRuta} from "../../Utilidades/useIrRuta";
import {useNavigate} from "react-router-dom";
import {irUrl} from "../../Utilidades/irUrl";
import {iniciarChatWass} from "../../Utilidades/iniciarChatWass";


const BarraPc = () => {
    const {ir} = useIrRuta()
    const navigate = useNavigate();

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                            <img src={logo} width={220} height={'auto'} alt={"logo"} onClick={() => navigate('/Home')}
                                 style={{cursor: 'pointer'}}
                            />
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'space-between'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{px: 6}}
                            >


                                {SECCIONES.map((item, index) => (
                                    <Typography
                                        onClick={() => ir(item)}
                                        sx={{
                                            fontFamily: NEGRITA,
                                            color: '#fff',
                                            cursor: 'pointer',
                                            borderBottom: 1,
                                            borderColor: '#ffffff00',
                                            transition: "all .2s ease-in-out",
                                            '&:hover': {
                                                borderColor: '#ffffff',
                                            }
                                        }}>{item}</Typography>
                                ))}

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-end'}}>
                            <Grid
                                container
                                justifyContent={'flex-end'}
                                alignItems={'center'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={2}
                            >

                                <IconButton sx={{p: 0}} onClick={() => irUrl(REDES[0].url)}>
                                    <img src={REDES[0].img} width={34} height={'auto'}/>
                                </IconButton>

                                <IconButton sx={{p: 0}} onClick={() => irUrl(REDES[1].url)}>
                                    <img src={REDES[1].img} width={34} height={'auto'}/>
                                </IconButton>

                                <IconButton sx={{p: 0}} onClick={() => irUrl(REDES[2].url)}>
                                    <img src={REDES[2].img} width={34} height={'auto'}/>
                                </IconButton>

                                <Button
                                    onClick={() => iniciarChatWass({})}
                                    sx={{color: theme.palette.primary.main}}
                                    startIcon={<WhatsApp/>}
                                    color="secondary"

                                >
                                    Contactar
                                </Button>


                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default BarraPc

